<template>
  <!-- 开通会员 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>

    <div class="content">
      <div class="ding">订好舱会员</div>
      <div class="kai">开通订好舱会员，体验更多完整功能</div>
      <div class="vip">
        <div class="xuan">选择会员套餐：</div>
        <div class="taocan" 
        v-for="item in titList"
        :key="item.id"
        :class="{ xztc: xzInd == item.id }" 
        @click="xuanz(item.id,item.price)">
          <div class="huiyuan">{{item.title}}</div>
          <div class="tiyan">{{item.describe}}</div>
          <div class="qian">
            <span>￥{{item.price}}</span>
            /
            {{
            item.time_type==1?
            '月':
            (
              item.time_type==2?
              '年':
              '年（企业定制-团购）'
              )
            }}
          </div>
          <el-button>立即开通</el-button>
          <div class="list">
            <div 
            v-for="ktem in conList"
            :key="ktem.id"
            class="list-item">
              <div class="list-it" v-if="ktem.item_rights['item'+item.id]==1">
                <div class="dian"></div>
                {{ktem.describe}}
              </div>
            </div>
        </div>
          <div v-if="xzInd == item.id" class="dui">
            <i class="el-icon-check"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="quanyi">
      <div class="tit">会员权益对比：</div>
      <table class="table">
        <tr class="theader">
          <td class="first">权益名称</td>
          <td 
          v-for="item in titList"
          :key="item.id">
          {{item.title}}
        </td>
        </tr>
        <!-- <tr 
        class="tbody" 
        v-for="item in conList"
        :key="item.id"
        >
          <td class="first">{{item.title}}：{{item.describe}}</td>
          <td>
            <i :class="item.item_rights.item2==1?'el-icon-check':'el-icon-close'"></i>
          </td>
          <td>
            <i :class="item.item_rights.item3==1?'el-icon-check':'el-icon-close'"></i>
          </td>
          <td>
            <i :class="item.item_rights.item5==1?'el-icon-check':'el-icon-close'"></i>
          </td>
        </tr> -->
        <tr 
        class="tbody" 
        v-for="item in conList"
        :key="item.id"
        >
          <td class="first">{{item.title}}：{{item.describe}}</td>
          <td
          v-for="(it,ind) in item.item_rights"
          :key="ind"
          >
            <!-- {{it}} -->
            <i :class="it==1?'el-icon-check':'el-icon-close'"></i>
          </td>
        </tr>
      </table>
    </div>

    <div class="zhifu">
      <div class="zf-left">
        <el-button
          @click="way = 1"
          :class="{ yue: way == 1 }"
          type="primary"
          icon="el-icon-search"
          >余额支付</el-button
        >
        <!-- <el-button
          @click="way = 2"
          :class="{ yue: way == 2 }"
          type="primary"
          icon="el-icon-search"
          >对公转账</el-button
        > -->
      </div>
      <div v-if="way == 1" class="zf-right">
        <div class="qian">
          应付金额：
          <span>￥</span>
          <span class="num">{{money}}</span>
        </div>
        <div class="ye">余额支付需确保余额充值余额不足则会开通失败</div>

        <div class="line"></div>
        <div class="xiaohao">
          <div>本次消耗余额：<span>￥{{money}}</span></div>
          <div class="cz">
            账户可用余额：
            <span>￥{{user_money}}</span>
            <el-button @click="$router.push('/Recharge')">充值</el-button>
          </div>
        </div>
        <el-button class="liji" @click="paySubmit">立即支付</el-button>
        <div class="xieyi">
          支付即同意
          <span>《余额支付协议》</span>
          <span>《会员服务协议》</span>
        </div>
      </div>
      <div v-if="way == 2" class="zf-right">
        <div class="qian">
          应付金额：
          <span>￥</span>
          <span class="num">{{money}}</span>
        </div>
        <div class="ye">转账后点击上传支付凭证等待审核</div>
        <div class="huikuan">
          <div class="first">1</div>
          <div>
            <div class="tit">请汇款至下方账户</div>
            <div>
                <span>收款公司：{{ payDetail.collecting_company }}</span>
                <span>开户行：{{ payDetail.opening_bank }}</span>
            </div>
            <div>收款账号：{{ payDetail.account_number }}</div>
          </div>
        </div>
        <div class="huikuan">
          <div class="first">2</div>
          <div>
            <div class="tit">完成后添加支付凭证</div>
            <div>
              <span>
                支付凭证示例：
                <button class="btn">点击查看</button>
              </span>
              <span>
                上传支付凭证：
                <button class="btn" @click="dialogFormVisible = true">
                  点击上传
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="xieyi">
          支付即同意
          <span>《会员服务协议》</span>
        </div>
      </div>
    </div>

    <!-- 对话框上传凭证 -->
    <el-dialog
      class="dialog"
      title="兑换码兑换"
      :visible.sync="dialogFormVisible"
    >
      <el-form>
        <!-- <el-form-item label="企业名称">
          <el-input
            placeholder="请输入认证时的数据"
            v-model="name"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="联系电话">
          <el-input
            placeholder="请输入认证时的数据"
            v-model="name"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
        <!-- https://test.speedyeta.com/api/63aceb4e62f44 -->
        <el-form-item label="支付凭证">
          <!-- :on-success="handleSuccess" -->
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
          >
            <img v-if="vcard" :src="vcard" class="upload" />
            <div class="shangchuan" v-else>
              <img src="@/assets/images/update.png" alt="" />
              <div>上传支付凭证</div>
            </div>
          </el-upload>
          <el-button v-if="vcard" class="YlBTN" type="text" @click="yulan"
            >预览</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="quxiao" @click="dialogFormVisible = false"
          >返回</el-button
        >
        <el-button
          type="primary"
          class="queren"
          @click="dialogFormVisible = false"
          >使用模版</el-button
        >
      </div>

      <el-dialog class="yulanImg" append-to-body :visible.sync="dialogVisible">
        <img class="tupp" :src="vcard" alt="" />
      </el-dialog>
    </el-dialog>
  </div>
</template>
        
<script>
import TopNavigation from "../HP/TopNavigationB.vue";
import {
  // vipLists,
  vipItemRights,
  supplierRechargeConfig,
  openVip,
  userCenter,
} from "@/api/api";
export default {
  components: {
    TopNavigation,
  },
  data() {
    return {
      xzInd: 0,
      // 支付方式
      way: 1,
      // 对话框打开状态、
      dialogFormVisible: false,
      vcard: "",
      // 上传凭证预览
      dialogVisible: false,
      dialogImageUrl:
        "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      headers: {
        token: localStorage.getItem("token"),
      },
      // 表格标题
      titList: [],
    //   表格内容
      conList:[],
      payDetail: {},
      money:0,
      user_money:JSON.parse(localStorage.getItem('userInfo')).user_money,
    };
  },
  methods: {
    xuanz(ind,money) {
      this.xzInd = ind;
      this.money = money
    },
    yulan() {
      this.dialogVisible = true;
      this.dialogImageUrl =
        "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png";
    },
    async getvipItemRights() {
      try {
        const res = await vipItemRights({ vip_type: 1 }, this.headers);
        if(res.code==1){
            this.titList=res.data.item
            this.conList=res.data.rights
        }
      } catch (error) {
        console.log(error,"失败");
      }
    },
    // 获取充值配置公司详情
    async getPayDetail() {
        try {
            // supplierRechargeConfig
            const res = await supplierRechargeConfig(this.headers);
            if (res.code == 1) {
            this.payDetail = res.data;
            }
        } catch (error) {
            console.log(error,"失败");
        }
    },
    // 立即支付
    async paySubmit(){
      let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
      if(is_authentication!=2){
        if(is_authentication==0){
            this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }else{
            this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }
        
        return
      }
      if(Number(this.money)>Number(this.user_money)){
        this.$message({
          type:'error',
          message:'余额不足，请充值'
        })
      }else{
        try {
          const res = await openVip({
            vip_item_id:this.xzInd
          },this.headers)
          if(res.code==1){
            this.$message({
              type:'success',
              message:'会员开通成功'
            })

            // 开通成功  重新存储金额  改变页面剩余金额
            this.user_money = Number(this.user_money)- Number(this.money)
            this.getUserInfo()
          }else{
            this.$message({
              type:'error',
              message:res.msg
            })
          }
        } catch (error) {
          console.log(error,'失败');
        }
      }
      
    },
    // 获取个人信息  更新用户vip到期时间
     async getUserInfo(){
        let token = localStorage.getItem('token')
        let headers = {
            'token':token
        }
        try {
            const res = await userCenter(headers);
            if(res.code==1){
                let storedObject = localStorage.getItem('userInfo');
                if(storedObject){
                    let obj = JSON.parse(storedObject);
                    obj.is_vip = res.data.is_vip;
                    obj.vip_expire_time = res.data.vip_expire_time;
                    obj.user_money = this.user_money
                    obj.total_amount = Number(obj.user_money) + Number(obj.freeze_money);
                    localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                }
            }else if(res.code==-1){
                this.$message({
                    type:'error',
                    message:'登录超时，请重新登录'
                })
            }
        } catch (error) {
            console.log(error,'获取用户信息失败');
        }
    },
  },
  mounted() {
    this.getvipItemRights();
    this.getPayDetail()
  },
};
</script>
    
<style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.Booking {
  background: #f9f9f9;
}

.content {
  height: 480px;
  background: linear-gradient(180deg, #edf5ff 0%, #ffffff 100%);
  border-radius: 0px 0px 0px 0px;
  box-sizing: border-box;
  padding: 58px;

  position: relative;

  .ding {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 26px;
    color: #0073f5;
    font-style: normal;
    text-transform: none;
    text-align: center;
  }

  .kai {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    font-style: normal;
    text-transform: none;
    text-align: center;
    margin-top: 8px;
  }

  .vip {
    position: absolute;
    top: 196px;
    left: 360px;

    display: flex;

    .xuan {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      margin-right: 32px;
    }
    .taocan {
      margin-right: 30px;
      width: 280px;
      height: 357px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 12px 12px 12px 12px;

      padding: 24px;

      box-sizing: border-box;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-style: normal;
      text-transform: none;

      cursor: pointer;

      position: relative;
      .huiyuan {
        font-size: 18px;
        color: #333333;
      }

      .tiyan {
        font-size: 14px;
        color: #999;
        margin-top: 8px;
        margin-bottom: 34px;
      }

      .qian {
        font-size: 16px;
        color: #999;
        span {
          color: #fe3300;
          font-size: 32px;
        }
      }

      .el-button {
        width: 232px;
        height: 40px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        font-size: 16px;
        color: #ffffff;
        margin-top: 8px;
        margin-bottom: 20px;
      }

      .ty {
        margin-bottom: 31px;
      }

      .qiye {
        width: 232px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #0073f5;
        color: #0073f5;
        background: #fff;
      }

      ul {
        margin: 0;
        li {
          font-size: 14px;
          color: #999999;
          margin-bottom: 8px;
        }
      }
    }
    // 选中样式
    // .taocan:hover{
    //     border: 1px solid #0073F5;
    // }

    .xztc {
      border: 1px solid #0073f5;
    }

    .dui {
      position: absolute;
      right: 0;
      bottom: 0;

      width: 48px;
      height: 28px;
      background: #0073f5;
      color: #fff;

      text-align: center;
      line-height: 28px;

      border-radius: 14px 0 10px 0;

      i {
        font-size: 16px;
      }
    }
  }
}

.quanyi {
  background: #fff;
  padding-top: 134px;
  display: flex;
  .tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #999999;
    font-style: normal;
    text-transform: none;
    margin-right: 32px;
    margin-left: 360px;
  }
}

.table {
  width: 1056px;
  border-spacing: 0;

  border-bottom: solid 1px #eee;

  margin-top: 4px;

  .theader {
    height: 48px;
    background: #f9f9f9;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
  }
  .first {
    padding-left: 24px;
    // width: 320px;
  }
  .tbody {
    height: 68px;
    background: #fff;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    td {
      border-bottom: solid 1px #eee;
    }
    .el-button {
      color: #0073f5;
      font-size: 14px;
    }

    .del {
      color: #fe3300;
    }

    span {
      color: #999999;
      font-size: 14px;
    }

    .el-icon-check {
      font-size: 20px;
      color: #0073f5;
      font-weight: 600;
    }

    .el-icon-close {
      font-size: 20px;
      color: #999;
      font-weight: 600;
    }
  }
}

.zhifu {
  background: #fff;
  padding-top: 48px;

  display: flex;
  .zf-left {
    margin-left: 360px;

    display: flex;
    flex-direction: column;
    .el-button {
      width: 140px;
      height: 60px;
      border-radius: 8px 8px 8px 8px;
      font-size: 16px;
      background: #edf6ff;
      color: #999999;
      border: 0;
      margin-left: 0;
    }
    .yue {
      background: #0073f5;
      color: #fff;
      border: 0;
    }
  }

  .zf-right {
    margin-left: 132px;
    width: 800px;
    // text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    .qian {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span {
        color: #fe3300;
      }

      .num {
        font-size: 40px;
      }
    }
    .ye {
      margin-top: 8px;
      width: 326px;
      height: 40px;
      background: #edf6ff;
      border-radius: 8px 8px 8px 8px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #0073f5;
      text-align: center;
      font-style: normal;
      text-transform: none;
      line-height: 40px;
    }

    .line {
      width: 800px;
      height: 1px;
      background: #eeeeee;
      border-radius: 0px 0px 0px 0px;
      margin-top: 40px;
      margin-bottom: 32px;
    }

    .xiaohao {
      display: flex;
      align-items: center;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;

      span {
        color: #333;
        font-size: 24px;
      }
      .cz {
        margin-left: 160px;
      }

      .el-button {
        width: 68px;
        height: 32px;
        background: #edf6ff;
        border-radius: 6px 6px 6px 6px;
        color: #0073f5;
        border: 0;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    .liji {
      width: 280px;
      height: 48px;
      background: #0073f5;
      border-radius: 12px 12px 12px 12px;
      border: 0;
      color: #fff;
      margin-top: 69px;
      margin-bottom: 48px;
    }
    .xieyi {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;

      span {
        color: #0073f5;
      }
      margin-bottom: 48px;
    }
    .first {
      width: 26px;
      height: 26px;
      background: #0073f5;
      color: #fff;
      text-align: center;
      line-height: 26px;
      border-radius: 50%;
      margin-right: 18px;
    }
    .huikuan {
      display: flex;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      margin-top: 49px;
      .tit {
        font-size: 18px;
        color: #333333;
        margin-bottom: 17px;
      }
      span {
        display: inline-block;
        margin-right: 80px;
        margin-bottom: 16px;
      }

      .btn {
        width: 87px;
        height: 34px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        color: #fff;
        border: 0;
        cursor: pointer;
        margin-bottom: 48px;
      }
    }
  }
}

.dialog {
  .el-form {
    border-bottom: solid 1px #eee;
  }
  :deep(.el-dialog) {
    width: 480px;

    .el-form-item__content {
      display: flex;
    }
  }
  :deep(.el-input) {
    input {
      width: 320px;
      height: 48px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }
  }

  .quxiao {
    width: 100px;
    height: 40px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    font-size: 14px;
    color: #999999;
    border: 0;
  }

  .queren {
    width: 100px;
    height: 40px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    border: 0;
    margin-left: 16px;
  }
}

.YlBTN {
  margin-left: 10px;
  margin-top: 140px;
}
.shangchuan {
  width: 320px;
  height: 168px;
  background: #f9f9f9;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #eeeeee;

  div {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
    line-height: 14px;
  }

  img {
    width: 32px;
    height: 32px;

    margin-top: 52px;
  }
}

.yulanImg {
  :deep(.el-dialog) {
    width: 480px;
    img {
      width: 100%;
    }
  }
}

.list-it{
  display: flex;
  align-items: center;
  font-size: 14px;
color: #999999;
margin-bottom: 8px;
  .dian{
    width: 6px;
  height: 6px;
  background: #999999;
  border-radius: 3px;
  margin-right: 7px;
  }
}
</style>